// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"u2-z"};